import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import AboutUsPage from './AboutUsPage';
import './AboutUsPage.less';

export const prefix = 'bm-p-about-us';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: AboutUsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
